<div class="loader-overlay" *ngIf="isLoading && type === 'full'">
  <div class="loader-container">
    <div class="loader-content">
      <!-- Animated Logo -->
      <div class="logo-container">
        <!-- Base grayscale logo -->
        <img 
          src="assets/images/dark-logo.png" 
          alt="Ezyhire Loading" 
          class="logo-image logo-base"
        />
        <!-- Colored logo that fills from left to right -->
        <img 
          src="assets/images/dark-logo.png" 
          alt="Ezyhire Loading" 
          class="logo-image logo-colored"
        />
        <!-- <div class="loading-spinner"></div> -->
      </div>
      
      <!-- Loading Text -->
      <!-- <div class="loading-text">
        <span class="loading-dots">Loading</span>
      </div> -->
    </div>
  </div>
</div> 

<div class="" *ngIf="type === 'partial'">
    <div class="logo-container">
        <!-- Base grayscale logo -->
        <!-- <img 
            src="assets/images/dark-logo.png" 
            alt="Ezyhire Loading" 
            class="logo-image logo-base"
        /> -->
        <!-- Colored logo that fills from left to right -->
        <img 
            src="assets/images/dark-logo.png" 
            alt="Ezyhire Loading" 
            class=" logo-colored"
        />
        <!-- <div class="loading-spinner"></div> -->
    </div>
</div>